import React, { useState, useEffect } from 'react';
import AdvertiserCard from '../components/Cards/AdvertiserCard';
import AdvertiserModal from '../components/Modals/AdvertiserModal';
import { apiRequest } from '../api';
import images from '../images';

const Advertisers = () => {
  const [advertisers, setAdvertisers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [selectedAdvertiser, setSelectedAdvertiser] = useState(null);

  const fetchAdvertisers = async () => {
    try {
      const data = await apiRequest('users/list', 'GET');
      setAdvertisers(data.data.users || []);
    } catch (error) {
      console.error('Ошибка при получении рекламодателей:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAdvertisers();
  }, []);

  const openModal = () => {
    setSelectedAdvertiser(null);
    setShowModal(true);
  };
  const openEditModal = (advertiser) => {
    setSelectedAdvertiser(advertiser);
    setShowModal(true);
  };
  const closeModal = () => {
    setShowModal(false);
    setSelectedAdvertiser(null);
    fetchAdvertisers();
  };

  if (loading) {
    return (
      <main className="main-content">
        <div className="myleads-container">
          <div className="loading-spinner">Загрузка...</div>
        </div>
      </main>
    );
  }

  return (
      <main className="main-content">
        <div className="advertisers-container">
          {/* Верхний блок с заголовком и кнопкой */}
          <div className="advertisers-header">
            <div className="advertisers-header-left">
              <img src={images.exportOutline} alt="Рекламодатели" className="header-icon"/>
              <h1 className="page-title">Рекламодатели</h1>
            </div>
            <div className="advertisers-header-right">
              <button className="btn btn-primary" onClick={openModal}>
                Добавить рекламодателя
              </button>
            </div>
          </div>

          {/* Нижний блок с карточками */}
          <div className="advertisers-list">
            {advertisers.length > 0 ? (
                advertisers.map((advertiser) => (
                    <div key={advertiser.id} className="advertiser-card-wrapper">
                      <AdvertiserCard advertiser={advertiser} onRefresh={fetchAdvertisers} onEditClick={openEditModal}/>
                    </div>
                ))
            ) : (
                <div className="no-data">Нет рекламодателей</div>
            )}
          </div>

          {/* Модальное окно создания/изменения рекламодателя */}
          <AdvertiserModal 
            isOpen={showModal} 
            onClose={closeModal} 
            advertiserData={selectedAdvertiser}
          />

        </div>
      </main>
);
};

export default Advertisers;
